import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { SortEnumType } from 'gql/graphql';

import { useEffect, useMemo } from 'react';

import { bimWorkOrderSeasonsGql } from '../bimWorkOrderQueries';

const requestId = 'bimWorkOrderSeasons';

export const useBimWorkOrderSeasons = (workOrderId?: number, withEffect?: boolean) => {
    const [bimWorkOrderSeasonsReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => ({ workOrderId, order: [{ year: SortEnumType.Asc }] }), [workOrderId]);

    const [bimWorkOrderSeasonsData, bimWorkOrderSeasonsStatus] = useRequest({
        requestId,
        query: bimWorkOrderSeasonsGql,
        variables,
        withEffect: withEffect && Boolean(workOrderId),
    });

    useEffect(() => {
        bimWorkOrderSeasonsReset(undefined);
    }, [bimWorkOrderSeasonsReset]);

    return {
        bimWorkOrderSeasonsData,
        bimWorkOrderSeasonsStatus,
    };
};
